import { render, staticRenderFns } from "./questionOutputMatrix.vue?vue&type=template&id=0517aa26"
import script from "./questionOutputMatrix.vue?vue&type=script&lang=js"
export * from "./questionOutputMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports